import React from "react";

const DashboardKpiCard = ({
  title,
  value,
  subtitle,
  icon,
  tone = "blue",
  onClick,
}) => {
  return (
    <button
      type="button"
      className={`dashboard-kpi dashboard-kpi--${tone}`}
      onClick={onClick}
      disabled={!onClick}
    >
      <div className="dashboard-kpi__top">
        <span className="dashboard-kpi__eyebrow">{title}</span>
        <span className="dashboard-kpi__icon">
          <i className={icon} />
        </span>
      </div>
      <div className="dashboard-kpi__value">{value}</div>
      <div className="dashboard-kpi__subtitle">
        {subtitle}
        {onClick && <i className="pi pi-arrow-up-right ml-2 text-xs" />}
      </div>
    </button>
  );
};

export default DashboardKpiCard;
